export default __webpack_public_path__ + "static/media/Android-en.af4086a3.gif";